import { motion } from "framer-motion";
import { MapPin, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP, buildWhatsappLink } from "@/lib/config";

const cards = [
  {
    type: "Presencial",
    icon: MapPin,
    title: "Mogi Guaçu",
    desc: "Atendimento presencial com toda estrutura para sua avaliação.",
    cta: "Agendar consulta",
    href: buildWhatsappLink(WHATSAPP.mogi_guacu),
    testId: "schedule-mogi",
    variant: "primary",
  },
  {
    type: "Presencial",
    icon: MapPin,
    title: "Artur Nogueira",
    desc: "Atendimento presencial com avaliação clínica completa.",
    cta: "Agendar consulta",
    href: buildWhatsappLink(WHATSAPP.artur_nogueira),
    testId: "schedule-artur",
    variant: "primary",
  },
  {
    type: "Online",
    icon: Monitor,
    title: "Atendimento online",
    desc: "Para pacientes de todo o Brasil, com toda a comodidade da telemedicina.",
    cta: "Agendar online",
    href: buildWhatsappLink(WHATSAPP.online),
    testId: "schedule-online",
    variant: "outline",
  },
];

const Locations = () => {
  return (
    <section
      id="atendimento"
      className="bg-[#F5EFE6]/40 py-20 md:py-32"
      data-testid="locations-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 max-w-3xl"
        >
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            Onde encontrar
          </p>
          <h2
            className="font-serif text-3xl leading-tight text-[#3E2723] sm:text-4xl lg:text-5xl gold-line"
            data-testid="locations-title"
          >
            Atendimento
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.7,
                  delay: i * 0.12,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="group flex flex-col rounded-3xl border border-[#EFEBE1] bg-white p-8 transition-all hover:-translate-y-2 hover:border-[#D4AF37]/30 hover:shadow-[0_20px_40px_rgba(212,175,55,0.12)]"
                data-testid={`location-card-${i}`}
              >
                <div className="flex items-center gap-3">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#F5EFE6] text-[#D4AF37] transition-colors group-hover:bg-[#D4AF37] group-hover:text-white">
                    <Icon className="h-5 w-5" strokeWidth={1.6} />
                  </span>
                  <p className="text-xs uppercase tracking-[0.25em] text-[#795548]">
                    {card.type}
                  </p>
                </div>
                <h3 className="mt-6 font-serif text-2xl text-[#3E2723] md:text-3xl">
                  {card.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#4E342E]/80 md:text-base">
                  {card.desc}
                </p>
                <Button
                  asChild
                  className={
                    card.variant === "primary"
                      ? "mt-8 rounded-full bg-[#D4AF37] px-6 py-5 text-xs uppercase tracking-[0.2em] text-white hover:bg-[#C5A059]"
                      : "mt-8 rounded-full border border-[#3E2723] bg-transparent px-6 py-5 text-xs uppercase tracking-[0.2em] text-[#3E2723] hover:bg-[#3E2723] hover:text-white"
                  }
                  data-testid={card.testId}
                >
                  <a href={card.href} target="_blank" rel="noopener noreferrer">
                    {card.cta}
                  </a>
                </Button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Locations;
